import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageGalleryOverlayService } from '../image-gallery-overlay.service';
import { filter } from 'rxjs/operators';
import { UserDataService } from 'src/app/util/user-data.service';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
})
export class ImageGalleryComponent {
  @Input() images: any[];
  @Input() deletePrivilege: string;
  @Output() deleteEvent = new EventEmitter<string>();

  constructor(
    private overlayService: ImageGalleryOverlayService,
    private userDataService: UserDataService
  ) {}

  viewImage(index: number) {
    const privileges = this.userDataService.privileges;
    const [resource, action] = this.deletePrivilege.split('/');
    const allow_delete = privileges?.get(resource)?.includes(action);

    this.overlayService
      .open({ images: this.images, index, allow_delete })
      .onClose$.pipe(filter((id) => !!id))
      .subscribe((id) => {
        this.deleteEvent.emit(id);
      });
  }
}
